import React from "react";
import { Box } from "@mui/material";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import { C, FONT_BODY, VISUALLY_HIDDEN } from "../../utils/designTokens";

/** "+1 (224) 336-0215" for a US/Canada number; anything else as stored. */
export function formatPhone(raw) {
  const s = String(raw || "").trim();
  const digits = s.replace(/\D/g, "");
  const local = digits.length === 11 && digits[0] === "1" ? digits.slice(1) : digits.length === 10 && !s.startsWith("+") ? digits : null;
  if (!local) return s;
  return `+1 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}

/** Step 2: who the order is for, in one compact row. */
function ContactDetails({ profile }) {
  const items = [
    { Icon: PersonOutlineRoundedIcon, label: "Name", value: profile?.name },
    { Icon: PhoneOutlinedIcon, label: "Phone", value: formatPhone(profile?.phone) },
    { Icon: MailOutlineRoundedIcon, label: "Email", value: profile?.email },
  ].filter((x) => x.value);

  return (
    <Box component="dl" sx={{ m: 0, display: "flex", flexWrap: "wrap", columnGap: 3, rowGap: 1.25 }}>
      {items.map(({ Icon, label, value }) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, maxWidth: "100%" }}>
          <Icon aria-hidden="true" sx={{ fontSize: 20, color: C.muted, flexShrink: 0 }} />
          <Box component="dt" sx={VISUALLY_HIDDEN}>{label}</Box>
          <Box
            component="dd"
            sx={{ m: 0, minWidth: 0, fontFamily: FONT_BODY, fontSize: 15, fontWeight: 500, color: C.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {value}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default React.memo(ContactDetails);
